"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsIn = void 0;
const yup_1 = require("yup");
const errors_1 = require("../../errors");
const validation_1 = require("../../validation");
exports.IsIn = (...vals) => (...decoratorParams) => validation_1.Validation.registerCustomValidation(...decoratorParams, yup_1.mixed().required('Field is required!').oneOf(vals, errors_1.FormError.notAllowedValue));
//# sourceMappingURL=is-in.decorator.js.map